// extracted by mini-css-extract-plugin
export default {"select":"Selectperson_select__11H-g","sprite":"Selectperson_sprite__3iNhs"};